<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <b-form-group>
          <b-form-checkbox-group
                  id="checkbox-group-1"
                  v-model="item.role"
                  :options="checkboxOptions"
                  name="flavour-1"
          ></b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>
    <button
      type="submit"
      class="btn btn-primary">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters({
      clientTypeList: 'clienttype/list/items'
    }),
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  async created () {
    if (!this.clientTypeList.length) {
      await this.getClientTypes()
    }
    this.clientTypesHandler()
  },

  data () {
    return {
      roles: {},
      checkboxOptions: []
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    ...mapActions({
      getClientTypes: 'clienttype/list/default'
    }),
    clientTypesHandler () {
      this.clientTypeList.forEach(clientType => {
        this.roles[clientType.roles[0]] = 0
        this.checkboxOptions.push({
          value: clientType.roles[0],
          text: clientType.title
        })
      })
    }
  }
}
</script>
